import { Box, Container, Paper, Typography } from "@mui/material";
import React from "react";
import Calendar from "./calendar.dynamic";

const Reservations: React.FC = () => {
  return (
    <Container sx={(theme) => ({ marginY: theme.spacing(8) })}>
      <Box
        sx={(theme) => ({
          display: "grid",
          gridTemplateColumns: "1fr 2fr",
          alignItems: "center",
          [theme.breakpoints.down("sm")]: { display: "block" },
        })}
      >
        <Box
          sx={(theme) => ({
            width: "100%",
            display: "flex",
            justifyContent: "center",
            [theme.breakpoints.down("sm")]: { display: "none" },
          })}
        >
          <img
            src="/illu/res.svg"
            alt=""
            style={{ width: "100%" }}
            loading="lazy"
          />
        </Box>
        <Box>
          <Typography
            variant="h4"
            component="h2"
            sx={(theme) => ({
              fontWeight: "bold",
              textAlign: "center",
              marginBottom: theme.spacing(2),
            })}
          >
            Rezervace stolů
          </Typography>
          <Paper>
            <Calendar />
          </Paper>
        </Box>
      </Box>
    </Container>
  );
};

export default Reservations;
